/**
 * The function gets backend's validation-alerts that are structured in hierarchy:
 * project validation-alerts -> list -> rows -> cells
 *
 * @returns {{
 *   name,
 *   validation-alerts: [],
 *   rows: [{
 *     id,
 *     validation-alerts: [],
 *     cells: [{
 *       id,
 *       description,
 *       field,
 *       value,
 *     }]|*[]
 *   }]|*[],
 * }[]|*[]}
 */
const importErrors = (errors = []) => {
  return (
    errors
      .filter((err) => err?.type === 'SheetProcessingException')
      .map((list) => {
        let rows = [];
        let listErrors = [];
        // Going through all lists and sorting errors concerning rows or the list itself
        list?.errors?.forEach((err) => {
          // If error is about the row, go through them
          if (err.type === 'RowProcessingException') {
            const row = err;
            if (isNaN(row?.row_index) || row?.row_index === undefined) return;

            let cells = [];
            let rowErrors = [];
            row?.errors?.forEach((err) => {
              // The same as in the list. If row has Cell errors - collect them. Otherwise, leave as is
              if (err.type === 'CellException') {
                const cell = err;
                cells.push({
                  id: cell?.column_index,
                  description: cell?.description,
                  field: cell?.field,
                  value: cell?.value,
                });
              } else {
                rowErrors.push(err);
              }
            });

            // In the end, each row and list has errors divided on their errors and errors of the child
            rows.push({
              id: row?.row_index,
              cells,
              errors: rowErrors,
            });
          } else {
            listErrors.push(err);
          }
        });

        return {
          name: list?.sheet_name || '',
          rows,
          errors: listErrors,
        };
      }) || []
  );
};

export default importErrors;
